import { connect } from 'react-redux';
import ModalCommentForm from './ModalCommentForm';
import { addFeaturesComment } from '../../../redux/actions';

const mapDispatchToProps = {
  onSubmit: addFeaturesComment,
};

export default connect(null, mapDispatchToProps)(ModalCommentForm);



// WEBPACK FOOTER //
// ./src/js/common/components/ModalCommentForm/FeaturesCommentForm.js